export default __webpack_public_path__ + "amous.PBysn.svg";